import { useEffect, useState } from "react";
import axios from "axios";
import { Certificate } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULT_ITEMS = [
  "WHO-GMP",
  "Schedule M (Revised)",
  "ISO 9001:2015",
  "GLP Certified",
  "FSSAI Approved",
  "DCGI Approved",
  "GMP Certified",
  "USP-NF Compliant",
  "1000+ Formulations",
  "100+ DCGI Approvals",
  "Bon-Heur Pharmaceuticals",
];

/**
 * MarqueeDataRibbon — a horizontally scrolling ribbon of certifications and
 * quality accreditations. Sits between sections as a low-contrast editorial
 * band. Pauses on hover, respects prefers-reduced-motion via CSS.
 *
 * Items are loaded from `pages.home.marquee.items` (array of strings) so admins
 * can edit them without a deploy. Falls back to a hardcoded default if the DB
 * doesn't have a config yet.
 */
export default function MarqueeDataRibbon({ items: overrideItems }) {
  const [items, setItems] = useState(overrideItems || DEFAULT_ITEMS);

  useEffect(() => {
    if (overrideItems) return;
    axios
      .get(`${API}/public/pages/home.marquee`)
      .then((r) => {
        const arr = r.data?.value?.items;
        if (Array.isArray(arr) && arr.length) setItems(arr);
      })
      .catch(() => {});
  }, [overrideItems]);

  const doubled = [...items, ...items];
  return (
    <div
      className="marquee-pause relative w-full overflow-hidden bg-[#0F172A] py-5 border-y border-white/5"
      data-testid="marquee-ribbon"
      aria-label="Bon-Heur Pharmaceuticals accreditations"
    >
      <div className="flex w-max animate-marquee gap-16 px-8">
        {doubled.map((it, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-3 font-mono text-xs tracking-[0.28em] uppercase text-white/50 whitespace-nowrap"
          >
            <Certificate size={14} weight="light" className="text-[#0EA5E9]" />
            {it}
          </span>
        ))}
      </div>
      {/* Soft edge fades so the ribbon feels seamless */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0F172A] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0F172A] to-transparent" />
    </div>
  );
}
